import getConfig from 'next/config'
import { get, del, patch, headers } from './fetch'
import { getPersonaApiPath } from '../utils/personaApiUtils'

const {
  publicRuntimeConfig: { AUTH0_IDENTITY_API },
} = getConfig()

const updatePreferences = value =>
  patch(getPersonaApiPath('/user/profile', AUTH0_IDENTITY_API), {
    headers: headers(),
    body: JSON.stringify({
      preferences: {
        fairprice: {
          channels: {
            email: value,
            text: value,
          },
        },
      },
    }),
  })

const deleteAuthoMetadata = metaData =>
  del(getPersonaApiPath(`/user-metadata/${metaData}`, AUTH0_IDENTITY_API), {
    headers: headers(),
  })

const getDetailsPartialMatchAccount = matchType =>
  get(`${AUTH0_IDENTITY_API}/sdk/user/link-account?matchType=${matchType}`, {
    headers: headers(null, true),
  })

const updateMatchingRecordStatus = (id, status) => {
  return patch(
    getPersonaApiPath('/user/link-account/update', AUTH0_IDENTITY_API),
    {
      headers: headers(null, true),
      body: JSON.stringify({
        'id': id,
        'status': status,
        'reason': '',
      }),
    }
  )
    .then(() => {
      // no response obj, do nothing
    })
    .catch(() => {
      // don't do anything if error
    })
}

const getMyinfoProfileAttribute = () => {
  return get(getPersonaApiPath('/user/profile/myinfo', AUTH0_IDENTITY_API), {
    headers: headers(),
  })
}

module.exports = {
  updatePreferences,
  deleteAuthoMetadata,
  getDetailsPartialMatchAccount,
  updateMatchingRecordStatus,
  getMyinfoProfileAttribute,
}
